__turbopack_context__.v({
  "hit": "search-hit-module__bUhNBa__hit",
  "snippet": "search-hit-module__bUhNBa__snippet",
  "subtitle": "search-hit-module__bUhNBa__subtitle",
  "title": "search-hit-module__bUhNBa__title",
});
